<style lang="scss" scoped>
.tracking-table{
    height: 300px;
    overflow: auto;
    padding:20px;
    &>div{
        display: table-row;
    }
    & span{
        display: table-cell;
        padding: 3px 6px;
    }
}
</style>



<template>
	<section class="tracking-table" >
		<header class="font-bold font-16">
			{{data.statusDetail}} By {{data.carrier}}
			<br>
			Tracking ID {{data.trackingCode}}
		</header>
        <div v-for="item in data.trackingDetails">
            <span>{{item.datetime}}</span>
            <span>{{item.statusDetail}}</span>
        </div>
	</section>
</template>

<script>
export default {
	props: ['data'],
}
</script>